import { CompareWithVehicleRecordsResponse } from "@tm/models"

export function mapArticleComparison(data: any): CompareWithVehicleRecordsResponse {
    return {
        ...data,
        attributes: data.attributes || [],
    }
}
